export enum HTTP_EVENT_TYPE {
    sending = 'START',
    response = 'DONE',
    received = 'RECEIVED',
    progress = 'IN_PROGRESS',
    errorResponse = 'FAILURE',
    compeleteUpload = 'COMPLETE',
    userAction = 'ACTION_BACKEND',
}